import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonVariants } from '@/components/shared/basic/button';
import Button from '@/components/shared/basic/button/button';

export interface ICard {
  id: number;
  image: StaticImageData;
  title: string;
  tags: string[];
  pointers: string[];
  button: {
    text: string;
    link: string;
  };
}

interface Props {
  className?: string;
  card: ICard;
}
const Card: FC<Props> = ({ className, card }) => {
  return (
    <div
      className={twMerge(
        'md:gap-4 gap-3 flex md:flex-col flex-row-reverse md:p-4 p-3 rounded-xl border border-[#2b2b2b] bg-[#131313]',
        className,
      )}
    >
      <Image
        className='md:w-[160px] md:h-[160px] w-[116px] h-[116px] rounded-lg object-cover'
        src={card.image}
        width={160}
        height={160}
        alt={card.title}
      />
      <div className='flex flex-col md:gap-[30px] gap-2 flex-1 items-start'>
        <div className='flex-1'>
          <p className='md:text-lg text-sm/[22px] font-bold text-grayZl-25 md:mb-2 mb-[5px]'>
            {card.title}
          </p>
          {/* <div className='flex flex-wrap gap-1.5 md:mb-4 mb-3'>
            {card.tags.map((i, index) => (
              <div
                key={index}
                className='md:text-xs/[20px] text-[10px]/[18px] uppercase bg-grayZl-850 rounded-full md:px-3 px-1.5'
              >
                {i}
              </div>
            ))}
          </div> */}
          <div className='h-px  border-t w-full border-grayZl-900 border-dashed md:mb-4 mb-3' />
          <ul className='flex flex-col md:gap-1.5'>
            {card.pointers.map((i, index) => (
              <li
                key={index}
                className='flex items-start md:gap-3 gap-1.5 md:text-sm text-[10px]/[18px]'
              >
                <div className='md:w-1 md:h-1 w-0.5 h-0.5 rounded-full bg-white mt-2' />{' '}
                {i}
              </li>
            ))}
          </ul>
        </div>
        <Link href={card.button.link}>
          <Button
            noRadius
            className='md:text-sm/[22px] text-[10px]/[18px] font-semibold md:py-[5px] md:px-3 py-[3px] px-2 rounded'
            size={0}
            variant={ButtonVariants.PRIMARY}
          >
            {card.button.text}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Card;
